<template>
  <div>
    <div v-if="!_isMobile()">
      <a-modal
        title="订单支付"
        :width="600"
        :dialog-style="{ top: '20px' }"
        :maskClosable="false"
        :visible="visible"
        :footer="null"
        @cancel="handleCancel"
      >
        <!-- <a-form layout="horizontal" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="订单号">
            <a-input v-model="payInfo.orderNo" placeholder="订单号" disabled/>
          </a-form-item>
          <a-form-item :label="'项目' + ( i + 1) +'金额'" v-for="(o, i) in orderList" :key="i">
            <a-input-number v-model="o.orderPrice" disabled/>
          </a-form-item>
        </a-form> -->

        <h3>请选择要支付的项目：</h3>

        <a-checkbox-group v-model="selectedOrder" name="orders" @change="changeOrderSelect">
          <a-checkbox v-for="(o, i) in orderList" :key="i" :value="o" style="display: block; margin: 8px 0;">
            项目{{  i + 1 }}： {{ o.orderPrice / 100 }} 元
          </a-checkbox>
        </a-checkbox-group>

        <h3>共计：{{ payInfo.orderPrice }} 元</h3>
        
        <div style="width: 400px;display:block;margin: auto;">
          <!-- <a-button v-if="!_isMobile()" @click="pay(1)" type="primary" icon="wechat">微信扫码支付</a-button>
          <a-button v-if="_isMobile() && !_isWeiXin()" @click="pay(2)" type="primary" icon="wechat">微信APP支付</a-button>
          <a-button v-if="_isWeiXin()" @click="pay(3)" type="primary" icon="wechat">微信支付</a-button>
          <a-divider type="vertical"></a-divider>
          <a-button v-if="!_isMobile()" @click="pay(4)" type="primary" icon="alipay">支付宝支付</a-button>
          <a-button v-if="_isMobile() && !_isWeiXin()" @click="pay(5)" type="primary" icon="alipay">支付宝APP支付</a-button> -->
          <a-button @click="pay(1)" type="primary" icon="wechat">微信扫码支付</a-button>
          <a-button v-if="_isWeiXin()" @click="pay(3)" type="primary" icon="wechat">微信支付</a-button>
          <a-divider type="vertical"></a-divider>
          <a-button @click="pay(4)" type="primary" icon="alipay">支付宝支付</a-button>
        </div>
        <a-divider></a-divider>
        <p style="line-height:1.3em;color: red;">财务系统更新处理反馈需一定时间，如显示“未支付”请等待30分钟后刷新再次查询结果，谢谢。</p>
      </a-modal>
    </div>
    <div v-else-if="_isMobile() && visible" class="mobilePayBox">
      <p class="payFormList"> <span class="payLable">订单号</span> {{ payInfo.orderNo }}</p>
      <p class="payFormList"> <span class="payLable">订单金额</span> {{ payInfo.orderPrice }} </p>
      <p class="payFormList"> <span class="payLable">支付方式</span> </p>
      <div class="displayCenterBetween" style="justify-content: space-around;">
        <img src="../../assets/aice2/WX_PAY.png" class="payImage" alt="" @click="pay(3)">
        <img src="../../assets/aice2/ZFB_PAY.png" class="payImage" alt="" @click="pay(5)">
      </div>
      <div class="displayCenter"><a-button type="danger" ghost style="margin: 40px auto;" @click="handleCancel">取消支付</a-button></div>
    </div>
    <UserAgreementModal ref="userAgreementModal"/>
  </div>
</template>
<script>
import Vue from 'vue'
import {randomUUID} from '@/utils/util'
import { getAction, postAction } from "@/api/manage";
import {mixinDevice} from '@/utils/mixin.js'
import UserAgreementModal from './UserAgreementModal'
export default {
  name: "EventPay",
  mixins: [mixinDevice],
  components: {
    UserAgreementModal
  },
  data() {
    return {
      visible: false,
      pcAlipayUrl: "https://pay.cacpaper.com/alipay/pay.jsp",
      mobileAlipayUrl: "https://pay.cacpaper.com/alipay/wap-pay.jsp",
      pcWxpayUrl: "https://pay.cacpaper.com/wxpay/pay", // 微信扫码支付
      pcUnionpayUrl: "https://pay.cacpaper.com/unionpay/pay",
      mobileWxpayUrl: "https://pay.cacpaper.com/wxpay/h5-pay", //微信H5支付 （未开通）
      mobileWxpayInWxUrl: "https://pay.cacpaper.com/wxpay/mp-pay", //公众号支付
      mobileWxpayInMiniAppUrl: "https://pay.cacpaper.com/minipay/mini-pay", //小程序支付
      bodyPrefix: 'AICE测评',
      orderList: [
        // {
        //   orderNo: '123',
        //   orderPrice: 100
        // },
        // {
        //   orderNo: '456',
        //   orderPrice: 200
        // }
      ],
      payInfo: {
      },
      selectedOrder: [],
      selecetPayType: 0,
      callbackUrl:  ""
    };
  },
  created() {
    //this.open(this.orderList)
    
  },
  mounted(){
    console.log(this.$refs);
  },
  methods: {
    open(orderInfoList){
      if(Object.prototype.toString.call(orderInfoList) === '[object Object]'){
        orderInfoList = [orderInfoList]
      }
      console.log(orderInfoList);
      this.orderList = orderInfoList
      this.selectedOrder = orderInfoList
      this.changeOrderSelect(orderInfoList)
      // this.payInfo = {
      //   orderNo: orderInfoList[0].orderNo,
      //   orderPrice: orderInfoList[0].orderPrice / 100
      // }
      //this.callbackUrl = window.location.protocol + "//" + window.location.host + "/cert/payResult.html?orderId=" + this.payInfo.orderNo
      this.callbackUrl = window.location.href + '#payok-' + this.payInfo.orderNo
      this.visible = true
      this.$refs.userAgreementModal.show()
    },
    handleCancel(){
      this.visible = false
      this.$emit("cancel")
    },
    changeOrderSelect(v){
      console.log(v);
      if(v.length == 0){
        this.$message.info('请至少选择一项')
        return
      }
      if(v.length > 1){
        let totalFee = v.map(i=>i.orderPrice).reduce((sum, curr) => sum + curr)
        this.payInfo = {
          orderPrice: totalFee / 100,
          orderNo: ''
        }
      }else{
        this.payInfo = {
          orderNo : v[0].orderNo,
          orderPrice: v[0].orderPrice / 100
        }
      }
     
    },
    //创建合并支付订单
    createCombineOrder(){
      let orderNoList = this.selectedOrder.map(i=>i.orderNo)
      postAction("/teaching/teachingOrder/createCombineOrder", orderNoList).then(res=>{
        if(res.success){
          this.payInfo = {
            orderNo: res.result.orderNo,
            orderPrice: res.result.orderPrice / 100
          }
          this.pay0()
        }
      })
    },
    //检查订单是否支付
    checkOrder(orderId){
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo="+orderId).then(res=>{
        if(res.success){
          this.$message.success('支付成功');
          this.$emit("payOk")
        }else{
          this.$message.error(res.message);
        }
      })
    },
    pay(type) {
      this.selecetPayType = type
      if(this.selectedOrder.length == 0){
        this.$message.info('请选择要支付的项目')
        return
      }
      //合并支付
      if(this.selectedOrder.length > 1){
        this.createCombineOrder()
        return
      }
      //单独支付
      this.pay0()
    },
    pay0(){
      console.log("pay0");
      console.log(this.payInfo);
      
      let that = this
      let realname =  this.$store.getters.userInfo.realname
      let body = this.bodyPrefix + "-" + realname + this.payInfo.orderNo
      switch(this.selecetPayType){
        case 1:
          this.pcWxpay(body, this.payInfo);
          break;
        case 2:
          this.mobileWxpay(body, this.payInfo);
          break;
        case 3:
          this.mobileWxpayInWx(body, this.payInfo);
          break;
        case 4:
          this.pcAlipay(body, this.payInfo);
           break;
        case 5:
          this.mobileAlipay(body, this.payInfo);
           break;
      }
      if(!this._isMobile()){
        this.$confirm({
          title: '是否支付成功?',
          content: '请在打开的页面进行付款，付款后，确认付款结果',
          onOk() {
            that.checkOrder(that.payInfo.orderNo)
          },
          okText: "支付成功",
          onCancel() {
            that.checkOrder(that.payInfo.orderNo)
            alert("如支付失败请到我的订单中找到该订单尝试刷新状态，如无法解决问题请致电4006982989咨询")
          },
          cancelText: "支付失败"
        });
      }
    },
    pcWxpay(body, payInfo) {
      let action = this.pcWxpayUrl;
      let params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_product_id: "101",
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl,
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileWxpay(body, payInfo) {
      let action = this.mobileWxpayUrl;
      let params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl,
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileWxpayInWx(body, payInfo) {
      let action = this.mobileWxpayInWxUrl;
      let params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url:this.callbackUrl,
      };
      
      let form = this.createForm(action, params, "_self");
      form.submit();
    },
    mobileAlipay(body, payInfo) {
      let action = this.mobileAlipayUrl;
      let params = {
        WIDout_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WIDsubject: body,
        WIDtotal_fee: payInfo.orderPrice,
        WIDbody: body,
        WIDreturn_url: this.callbackUrl
      };
      let form = this.createForm(action, params, "_self");
      form.submit();
    },
    pcAlipay(body, payInfo) {
      let action = this.pcAlipayUrl;
      let params = {
        WIDout_trade_no: payInfo.orderNo,
        WIDsubject: body,
        original_id: payInfo.orderNo,
        WIDtotal_fee: payInfo.orderPrice,
        WIDbody: body,
        WIDreturn_url:this.callbackUrl
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    pcUnionpay(body, payInfo) {
      let action = this.pcUnionpayUrl;
      let params = {
        orderId: payInfo.orderNo,
        txnAmt: payInfo.orderPrice,
        original_id: payInfo.orderNo,
        WIDsubject: "报名-"+body,
        WIDbody: body,
        channel: "pc",
        frontUrl: this.callbackUrl
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileUnionpay(body, payInfo) {
      let action = this.pcUnionpayUrl;
      let params = {
        orderId: payInfo.orderNo,
        txnAmt: payInfo.orderPrice,
        original_id: payInfo.orderNo,
        WIDsubject: "报名-"+body,
        WIDbody: body,
        channel: "mobile",
        frontUrl:this.callbackUrl
      };
      let form = this.createForm(action, params, "_blank");
      form.submit();
    },
    //创建post表单
    createForm(action, params, target) {
      console.log("createForm");
      console.log(action);
      console.log(params);
      //alert(JSON.stringify(params))
      var temp = document.createElement("form"); //创建form标签
      temp.action = action; //这里写URL
      temp.method = "post"; //post方式提交
      temp.target = target
      temp.style.display = "none"; //设置为不可见
      for (var key in params) {
        var element;
        element = document.createElement("input");
        element.setAttribute("type", "hidden");
        element.name = key;
        element.value = params[key];
        temp.appendChild(element);
      }
      document.body.appendChild(temp); //将form标签添加到body标签内
      return temp;
    },
  },
};
</script>

<style lang="less" scoped>
.mobilePayBox{
  width: 100vw;
  height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 199;
  background: #fff;
  .payFormList{
    font-size: 14px;
    color: #323335;
    line-height: 22px;
    display: flex;
    align-items: center;
    .payLable{
      display: inline-block;
      width: 100px;
      color: #969AA0;
    }
  }
  .payImage{
    width: 60px;
    height: 60px;
  }
}
</style>